import { render, staticRenderFns } from "./OptimizationSeoDialog.vue?vue&type=template&id=bff63d56&scoped=true&"
import script from "./OptimizationSeoDialog.vue?vue&type=script&lang=js&"
export * from "./OptimizationSeoDialog.vue?vue&type=script&lang=js&"
import style0 from "./OptimizationSeoDialog.vue?vue&type=style&index=0&id=bff63d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff63d56",
  null
  
)

/* custom blocks */
import block0 from "./OptimizationSeoDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports